import { schema } from 'normalizr';
import { decode } from 'html-entities';

const plugin = new schema.Entity(
  'plugins',
  {},
  {
    processStrategy(value, _parent, _key) {
      return {
        ...value,
        data: decode(value.data),
      };
    },
    idAttribute: (plugin) => plugin.name || plugin.itemId,
  }
);

export default plugin;
